import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const CSMAModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="CSMA, CSMA/CD, and CSMA/CA"
    videos={[
      "https://www.youtube.com/embed/8wptjECeGA8",
      "https://www.youtube.com/embed/xGzDbJz-AJ8",
      "https://www.youtube.com/embed/DCnyumoiHsk",
      "https://www.youtube.com/embed/SX7fHX-IKek"
    ]}
    takeaways={[]}
    questions={[
      "Write a detailed comparative analysis of how ALOHA, Slotted ALOHA, CSMA, CSMA/CD, and CSMA/CA react during multiple access transmission in terms of Tfr, Tp, Tb, and vulnerable time. State the reason for Tfr >= 2 x Tp.",
      "Two hosts are in a CSMA/CD network and the medium has a data transfer capacity of 1Gbps. The minimum frame length is fixed to 1,000 bits and the propagation speed is 2 ×10^8 m/s. i) What will be the distance between the hosts? ii) If it is an Ethernet network, what is the efficiency when the hosts have a maximum distance between them? If the distance is reduced to 1 m, does it impact the efficiency?",
      "Distinguish between CSMA/CD and CSMA/CA. With flowchart elucidate the working scenario of CSMA/CA and Pure ALOHA.",
      "In a local area network (LAN) using CSMA, a device called Device A wants to transmit data. Before sending, it listens to the channel and detects that it is idle. Device A begins transmitting its data. Just after it starts transmitting, Device B also senses that the channel is idle and starts transmitting simultaneously. Explain what happens next and how CSMA helps manage this situation.",
      "A network engineer is trying to decide whether to implement a CSMA or CSMA/CD protocol in a newly designed local area network. Discuss the advantages of using CSMA/CD over CSMA in terms of efficiency and collision management."
    ]}
    exampleVideos={[]}
  />
);
}

export default CSMAModule;
